import { useQuery, useMutation } from "@tanstack/react-query";
import { fetchAllHsn } from "services/hsn";

export const useAllHsn = (filters = {}) => {
  const query = useQuery({
    queryKey: ["all-hsn", filters],
    queryFn: () => fetchAllHsn(filters),
  });
  return query;
};
